import { FunctionComponent } from "react";
import { SecaoButao } from "../../../components/formulario/styled";
import ModalExportar from "../../../components/modalExportar";
import PopUpFiltroListaMembros from "./PopUpFiltro";
import SearchInput from "../../../components/inputs/searchInput";
import OpenExcelUniversal from "../../../components/excel/OpenExcelUniversal";
import DonwloadPdf from "../../../components/pdf/DonwloadPdf";
import { UseListMembros } from "./context/ListMembros";


interface HeaderAssociarMembroPgProps {

}

const HeaderAssociarMembroPg: FunctionComponent<HeaderAssociarMembroPgProps> = () => {

  const { getSearchPerNameEmail, list, isLoading } = UseListMembros()

  return (<>
    <SecaoButao style={{ marginBottom: 5 }}>
      <section style={{ display: 'flex', gap: 5 }}>
        <ModalExportar
          idLoadingData={isLoading}
          callDownloadExcel={() => OpenExcelUniversal(list, ["usuario", "nome", "telefone", "email", "nomesede", "nomeministerio", "nomecelula", "nomecargo"])}
          callDownloadPdf={() => DonwloadPdf(list, ['Id', 'Nome', 'Telefone', 'E-mail', 'Sede', 'Ministério', 'PG', 'Cargo'], ["usuario", "nome", "telefone", "email", "nomesede", "nomeministerio", "nomecelula", "nomecargo"], list?.length, [], `${list?.length}`)}
        />
        <PopUpFiltroListaMembros />

      </section>
      <SearchInput
        title='Procure por Telefone, nome ou email'
        placeholder="Procure por Telefone, nome ou email"
        onChange={getSearchPerNameEmail}
      />
      <section />
    </SecaoButao>
  </>);
}

export default HeaderAssociarMembroPg;
